var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.303 29.274V26.5467C30.303 24.0051 28.5647 21.8695 26.2121 21.264M21.4394 5.125C23.4384 5.93417 24.8485 7.89394 24.8485 10.1831C24.8485 12.4722 23.4384 14.432 21.4394 15.2411M23.4848 29.274C23.4848 26.7325 23.4848 25.4617 23.0696 24.4593C22.516 23.1228 21.4542 22.061 20.1177 21.5074C19.1153 21.0922 17.8445 21.0922 15.303 21.0922H11.2121C8.67061 21.0922 7.39986 21.0922 6.39747 21.5074C5.06096 22.061 3.9991 23.1228 3.4455 24.4593C3.03029 25.4617 3.03029 26.7325 3.03029 29.274M18.7121 10.1831C18.7121 13.1955 16.27 15.6376 13.2576 15.6376C10.2451 15.6376 7.80302 13.1955 7.80302 10.1831C7.80302 7.1706 10.2451 4.72852 13.2576 4.72852C16.27 4.72852 18.7121 7.1706 18.7121 10.1831Z",
    stroke: "#379E66",
    strokeWidth: 2.72727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d644197765d9dc613da60842a882f0f2.svg";
export { ForwardRef as ReactComponent };